<template>
  <div>

    <vat-declarations-view
        @reloadVatDeclarations="fetchVatDeclarations($event)"
    />

  </div>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'

import VatDeclarationsView from '../../../components/views/VatDeclarationsView.vue'
import useAPI from '../../../utils/useAPI'

export default {
  components: {
    VatDeclarationsView
  },
  props: {},
  setup () {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const {
      fetchVatDeclarations,
      fetchAutocompletePaymentMethods,
      fetchAutocompleteBankAccounts
    } = useAPI()

    const test = (x) => {
      console.log(x)
    }

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    fetchVatDeclarations()
    fetchAutocompletePaymentMethods()
    fetchAutocompleteBankAccounts()

    return {
      // Components

      // Data

      // Computed

      // Methods
      fetchVatDeclarations,
      test,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>